<template>
  <div class="books-preview" :style="{ backgroundColor: $$FormData.boxBackgroundColor }">
    <div v-for="item in $$FormData.books" :key="item.id" class="video-item"
      :style="{ borderBottomColor: $$FormData.videoLineColor }">
      <img :src="item.cover_image" class="video-cover" alt="" />
      <div class="video-info">
        <div class="video-title ellipsis" :style="{ color: $$FormData.videoTitleColor }">
          {{ item.name }}
        </div>
        <div class="video-desc ellipsis-2" :style="{ color: $$FormData.videoDescColor }">
         <span v-html="item.introduction"></span>
 
        </div>
      </div>
    </div>
    <div v-if="!$$FormData.books.length" class="empty">
      请选择视频
    </div>
  </div>
</template>

<script>
export default {
  name: 'BookVideosPreview'
}
</script>

<style scoped lang="scss">
.books-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10px;
  // background: #ffffff;
}

.video-item {
  display: flex;
  justify-content: space-between;
  gap: 14px;
  width: 343px;
  overflow: hidden;
  padding-bottom: 20px;
  border-bottom: 1px solid #e9e9e9;
  margin-top: 16px;

  &:last-child {
    border-bottom: none;
  }

  .video-cover {
    width: 134px;
    height: 89px;
    border-radius: 10px;
    flex-shrink: 0;
  }

  .video-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
  }

  .video-title {
    color: #3C4353;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
  }

  .video-desc {
    color: #A6AAB8;
    font-size: 12px;
    line-height: 18px;
  }
}

.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999999;
  width: 100%;
  height: 75px;
}</style>